import React, { useState } from 'react';
import Select from 'react-select';

interface Props {
    onChange: (name: string, value: number | string | undefined) => void;
    value: string | number | boolean | undefined;
    name: string;
}

const ClassificationSelector: React.FC<Props> = ({ onChange, value, name }) => {
    const options = [
        { label: 'ORO', value: 1 },
        { label: 'PLATA', value: 2 },
        { label: 'BRONCE', value: 3 },
    ];

    const [selectedOption, setSelectedOption] = useState<{
        label: string;
        value: number | string;
    } | null>(options.find((option) => option.value === value) || null);

    const handleChange = (
        newValue: { label: string; value: number | string } | null
    ) => {
        setSelectedOption(newValue);
        onChange(name, newValue?.value);
    };

    return (
        <div className='mb-2'>
            <label htmlFor={name} className='form-label form-label'>
                Clasificación *
            </label>
            <Select
                className='basic-single'
                classNamePrefix='select'
                isSearchable
                name={name}
                options={options}
                onChange={handleChange}
                value={selectedOption}
            />
        </div>
    );
};

export default ClassificationSelector;
